import { ChartWidgetMetadata } from '@/modules/ta/widget/models/metadata/ChartWidgetMetadata';
import { BarChartDrawOption } from '@/modules/ta/widget/models/drawoptions/BarChartDrawOption';

export class BarChartWidgetMetadata extends ChartWidgetMetadata {
  /**
   * Per-metric forecast config keyed by metric field:
   * { [field]: { enabled: boolean, line_style: string } }
   *
   * @var {Object}
   */
  forecast_metrics;

  /**
   * Chart-level forecast config:
   * { horizon_days, method, show_confidence_band, confidence_level }
   *
   * @var {Object}
   */
  forecast_config;

  constructor(model = {}) {
    super(model);

    this.draw_options = new BarChartDrawOption(model.draw_options);
    this.initForecastMetadata(model);
  }
}
